export default __webpack_public_path__ + "static/error1-79e916f0589b90940a5c793000298cb6.png";